/**
 * Convert a base64 audio string into an object URL
 * @param base64 - Base64 string (may include data URI prefix)
 * @param mimeType - e.g. "audio/wav" | "audio/mpeg" | "audio/ogg"
 * @returns Object URL
 */
export function base64ToAudioUrl(base64: string, mimeType = 'audio/wav') {
  // Remove prefix if present (e.g., "data:audio/wav;base64,...")
  const base64Data = base64.split(',')[1] || base64;

  const binaryString = atob(base64Data);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: mimeType });
  return URL.createObjectURL(blob);
}
